export default {
  activeExposurePart: { name: 'Full Exposure', value: 'full' },
  exposurePartOptions: [
    { name: 'Full Exposure', value: 'full' },
    { name: 'Source of Funds', value: 'incoming' },
    { name: 'Use of Funds', value: 'outgoing' },
  ],
  activeExposureTable: { name: 'Received From', value: 'incoming' },
  exposureTableOptions: [
    { name: 'Received From', value: 'incoming' },
    { name: 'Sent To', value: 'outgoing' },
  ],
  activePartBar: { name: 'Risk Labels', value: 'type' },
  partBarOptions: [
    { name: 'Risk Labels', value: 'type' },
    { name: 'Entity', value: 'entity' },
  ],
  activeTypeEntityItem: {},
  activePartBarUof: { name: 'Risk Labels', value: 'type' },
  activePartBarFull: { name: 'Risk Labels', value: 'type' },
  activeExposurePartUof: { name: 'Full Exposure', value: 'full' },
  activeExposurePartFull: { name: 'Full Exposure', value: 'full' },
  activeTypeEntityItemUof: {},
  activeTypeEntityItemFull: {},
}
